import React, { useContext } from 'react';
import _ from 'lodash';

import type { MarketCountries } from '@ww-digital/web-palette-react/dist/components/Utility/Market';
import type { FooterLandingPageProps } from '@ww-digital/web-palette-react/dist/components/Slice/FooterLandingPage/FooterLandingPage';
import type { MarketContextType } from '../../../context/market.context';
import type { ConfigContextType } from '../../../context/config.context';

import { FooterLandingPageSlice } from '@ww-digital/web-palette-react/dist/components/Slice/FooterLandingPage/FooterLandingPage';
import { Market } from '@ww-digital/web-palette-react/dist/components/Utility/Market';
import { AnalyticsUtility } from '../../Utility/AnalyticsUtility.ts';
import { MarketContext } from '../../../context/market.context.ts';
import { ConfigContext } from '../../../context/config.context.ts';

interface FooterLandingPageSliceContainerProps {
  daCategory: string;
  slice: FooterLandingPageProps;
}

export const FooterLandingPageSliceContainer = ({
  daCategory,
  slice,
}: FooterLandingPageSliceContainerProps): JSX.Element => {
  const getProcessedAttributes = (attributes: string) => {
    try {
      const parsed = JSON.parse(attributes);
      return parsed;
    } catch (e) {
      return {};
    }
  };

  const sliceNavigation = _.isArray(slice.navigation)
    ? slice.navigation.map((link) => {
        const analyticsAttributes = {
          'da-category': daCategory,
          'da-action': AnalyticsUtility.formatAction(
            'nav_footer_legal',
            link.text,
          ),
          'da-label': AnalyticsUtility.formatLabel(link.text),
        };

        const attributes = getProcessedAttributes(link.attributes);

        return {
          ...link,
          attributes: {
            ...analyticsAttributes,
            ...attributes,
          },
        };
      })
    : [];

  const { country, language, marketBasePath } =
    useContext<MarketContextType>(MarketContext);
  const { translations } = useContext<ConfigContextType>(ConfigContext);
  const countryName = Market.getCountryName(
    country as MarketCountries,
    language,
  );

  return (
    <FooterLandingPageSlice
      {...slice}
      navigation={sliceNavigation}
      country={{
        countryCode: country,
        countryName,
        countryLink: `${marketBasePath}/international`,
        title: `${translations.GLOBAL_FOOTER_FLAG_LABEL} (${countryName})`,
        attributes: {
          'da-category': 'navigation',
          'da-action': 'footer_international_click',
          'da-label': `${language}-${country}`,
        },
      }}
      legitScript={country === 'us'}
    />
  );
};
